module.exports = __webpack_public_path__ + "static/media/ANM019-Cameron-Shafii03.588b8766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ANM019-Cameron-Shafii03.jpg
// module id = 96
// module chunks = 0